import React from 'react';

function Logo(props) {

    const styles = {
        maxWidth: props.width || "150px",
    };

    return (
        <img
            src={props.src}
            style={Object.assign(styles, props.style)}
            className="logo"
        />
    );
}

export default Logo;